import axios from 'axios';
import { get } from 'lodash';
import { URL } from 'config/config';
import { showAlert } from './alert';
import moment from 'moment-timezone';

export const SET_OFFTIMES_LOADING = 'SET_OFFTIMES_LOADING';
export const SET_OFFTIMES = 'SET_OFFTIMES';


const setOffTimesLoading = (value = true) => ({
    type: SET_OFFTIMES_LOADING,
    payload: value
});
const setOffTimes = payload => ({
    type: SET_OFFTIMES,
    payload
});

export const fetchOffTimes = (providerId, filter) => async dispatch => {
    dispatch(setOffTimesLoading(true));
    try {
        let from = moment().subtract(1, 'year').unix();
        let to = moment().add(1, 'year').unix();
        if (filter === "upcoming") {
            from = moment().startOf('day').unix();
            to = moment().add(1, 'year').unix();
        }
        if (filter === "past") {
            from = moment().subtract(1, 'year').unix();
            to = moment().subtract(1, 'day').endOf('day').unix();
        }
        console.log("Changed : ", filter, from, to);

        const response = await axios.get(`${URL.OFF_TIME}?providerId=${providerId}&from=${from}&to=${to}`);
        if (response && response.data.success) {
            const data = get(response, 'data.objects', []);
            dispatch(setOffTimes(data.sort((a, b) => a?.startSec - b?.startSec)));
            dispatch(setOffTimesLoading(false));
            return data
        }
    } catch (err) {
        dispatch(setOffTimesLoading(false));
    };
}

export const createOffTime = (payload, selectedProvider, filter) => async dispatch => {
    try {
        dispatch(setOffTimesLoading(true));
        const response = await axios.post(URL.OFF_TIME, payload);
        if (response && response.data.success) {
            const data = response.data;
            dispatch(fetchOffTimes(selectedProvider,filter));
            dispatch(setOffTimesLoading(false));
            dispatch(showAlert('success', "Off-Time added successfuly"))
            return data.object;
        } else if (response?.data?.message) {
            dispatch(showAlert('error', response?.data?.message))
        }
    } catch (err) {
        if (err?.message) {
            dispatch(showAlert('error', err?.message))
        }
    };
}


export const deleteOffTime = (offTimeId, selectedProviderId, filter) => async dispatch => {
    try {
        const response = await axios.delete(URL.OFF_TIME + `/${offTimeId}`);
        if (response && response.data.success) {
            dispatch(showAlert('success', "Off-Time deleted successfuly"));
            dispatch(fetchOffTimes(selectedProviderId, filter));
            return true
        } else if (response?.data?.message) {
            dispatch(showAlert('error', response?.data?.message))
        }
    } catch (err) {
        if (err?.message) {
            dispatch(showAlert('error', err?.message))
        }
    };
}